import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React from 'react';

type Size = 'tiny' | 'small' | 'medium' | 'large';

type Props = {
  className?: string;
  size?: Size;
  center?: boolean;
  dataTestId?: string;
  showLabel?: boolean;
  theme?: 'light' | 'dark';
};

export const Spinner = ({
  className,
  size = 'tiny',
  center,
  showLabel = false,
  dataTestId,
  theme = 'light',
}: Props) => {
  const { t } = useTranslation();
  return (
    <div
      aria-atomic="true"
      role="alert"
      aria-live="polite"
      data-testid={dataTestId}
      className="flex items-center flex-col gap-2"
    >
      <div
        className={cx(
          'min-h-[1rem] min-w-[1rem] animate-spin rounded-full border-solid !border-t-blue-500 ',
          {
            'm-auto': center,
            'h-4 w-4 border-2': size === 'tiny',
            'h-6 w-6 border-2': size === 'small',
            'h-8 w-8 border-4': size === 'medium',
            'h-10 w-10 border-4': size === 'large',
            'border-blue-200': theme === 'light',
            'border-spring-neutral-b4': theme === 'dark',
          },

          className,
        )}
      ></div>
      <div className={cx({ 'sr-only': !showLabel })}>{t('loading')}</div>
    </div>
  );
};
